import React from 'react';
import { connect } from 'react-redux';
import Main from '../components/Main';
import 'core-js/fn/object/assign';
import { GetStorageItem } from '../utilities/storageHelper';
import queryString from 'query-string';
import appConfig from '../config/';
import {
    getShopsAtAddress, setLanguage, setCallback, showShopDetails,
    setOption, setCountry, getShopsAtUserPosition, applyFilter,
    setMapCenter, setMapZoom
} from '../actions';

import hpsf from '../sources/HermesPSF.js';

class MainContainer extends React.Component {

    constructor(props) {
        super(props);
    }

  UNSAFE_componentWillMount() {
        /**
         * PARSE THE LEGACY AND URL PARAMS
         */
        const config = queryString.parse(location.search);
        const userLang = navigator.language || navigator.userLanguage;

        // LANGUAGE
        if (config.lang) {
            this.props.handle_setLanguage(config.lang.substr(0, 2));
        } else {
            // GET BROWSER LANGUAGE
            this.props.handle_setLanguage(userLang.substr(0, 2).toLowerCase());
        }

        // COUNTRIES (restricts the search to that country/countries(?))
        if(config.countries) {
            this.props.handle_setCountry(config.countries.toUpperCase());
        } else {
            this.props.handle_setCountry('DE');
        }

        // SEARCH OPTIONS aka filter
        let time = !!config.time && config.time.split(':');
        // FIXME: the determination of the day can be refactored. a lot in various
        // places. start by using import {days} from './something'; etc
        const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        const isOneOf = (a, values) => (values.indexOf(a) !== -1);
        const trueValues = ['on', 'true'];
        const isTruthy = value => isOneOf(value, trueValues);

        let filter = {
            // acceptsSuitcases == on?
            // hasBoxes == on?
            // open == on?
            // + weekday + time
            boxes: isOneOf(config.package, trueValues),
            luggage: isOneOf(config.db, trueValues) || isOneOf(config.acceptsSuitcases, trueValues),
            time: {
                enable: isOneOf(config.open, trueValues),
                hour: !!time ? time[0] : '12',
                minute: !!time ? time[1] : '00',
                day: config.weekday && days[parseInt(config.weekday,10)-1].toUpperCase()
            }
        };

        // DEFAULT MAP SETTINGS
        // let defaultCountry = store.getState().config.country || 'de'; //! dynamic
        let defaultCountry = config.countries || 'de';
        const defaults = appConfig.countryOptions[defaultCountry.toLowerCase()];
        const defaultCenter = {lat: defaults.lat, lng: defaults.lng};
        const defaultZoom = defaults.zoom;

        // UPDATE MAP
        this.props.handle_setMapCenter(defaultCenter);
        this.props.handle_setMapZoom(defaultZoom);
        this.props.handle_applyFilter(filter);

        // pass parameters to hpsf. used for parameters like consumerName etc, country,
        // and similar.
        hpsf.mapLegacyOptions(config);
        //hpsf.pushToDataLayer(config);

        // SET CALLBACK ADDRESS
        if (config.cb_address) {
            this.props.handle_setCallback(config.cb_address);
        }

        // HIDE HEADER/FOOTER
        if(config.noframe === 'true') {
            this.props.handle_setOption('noframe', true);
        }

        // DEFAULT SEARCH STRING {
        let query = '';

        // STREET
        if (config.street) {
            query += config.street;
            if (config.zip || config.city) {
                query += ', ';
            }
        }

        // ZIP CODE
        if (config.zip) {
            query += config.zip;
            if (config.city) {
                query += ' ';
            }
        }

        // CITY
        if (config.city) {
            query += config.city;
        }

        if (query !== '') {
            // store.dispatch(getShopsAtAddress(decodeURIComponent(query), store.getState().config.country)); //! dynamic
            let countries = config.countries || 'de'; // used for Maps-country-restriction (componentRestrictions)
            this.props.handle_getShopsAtAddress(decodeURIComponent(query), countries);
        }

        // open detail overlay asap if shopId is set.
        if (config.shopid) {
            this.props.handle_showShopDetails(config.shopid);
        }

        if (config.detailsInTab === '1' || config.detailsintab === '1') {
            this.props.handle_setOption('detailsInTab', true);
        }

        // setting sortCode1
        if(config.sortCode1) {
            this.props.handle_setOption('sortCode1', parseInt(config.sortCode1, 10));
        }

        if(config.options && isTruthy(config.options)) {
            this.props.handle_setOption('options', true);
        }

        if(config.cb_method && config.cb_method == 'link') {
            this.props.handle_setOption('cb_method', 'link');
        }

        // we successfully received geo location before, so let's get it again.
        // unless a search parameter is set of course.
        if(!config.city && !config.zip && !config.street && GetStorageItem('geo-location', 'allowed')) {
            this.props.handle_getShopsAtUserPosition();
        }
    }

    render() {
        return (
            <Main/>
        )
    }
}

//Use Action Creators in this component
const mapDispatchToProps = dispatch => (
    {
        handle_setMapCenter: (defaultCenter) => dispatch(setMapCenter(defaultCenter)),
        handle_setMapZoom: (defaultZoom) => dispatch(setMapZoom(defaultZoom)),
        handle_applyFilter: (filter) => dispatch(applyFilter(filter)),
        handle_setCallback: (cb_address) => dispatch(setCallback(cb_address)),
        handle_setOption: (par1, par2) => dispatch(setOption(par1, par2)),
        handle_showShopDetails: (shopid) => dispatch(showShopDetails(shopid)),
        handle_getShopsAtUserPosition: () => dispatch(getShopsAtUserPosition()),
        handle_getShopsAtAddress: (par1, par2) => dispatch(getShopsAtAddress(par1, par2)),
        handle_setLanguage: (lang) => dispatch(setLanguage(lang)),
        handle_setCountry: (country) => dispatch(setCountry(country))
    }
)

//Connect component to Redux Store
export default MainContainer = connect(null, mapDispatchToProps)(MainContainer);
